<template>
  <div class="top-layout-banner">
    <div class="title">{{ topLayoutBannerData.title }}</div>

    <BaseButton
      class="button"
      :name="topLayoutBannerData.buttonName"
      size="l"
      @click="navigateToProfile"
    />
  </div>
</template>

<script lang="ts" setup>
  import { BaseButton } from '~/components/base-ui/buttons'
  import { useUserStore } from '~/store/user'

  const img = useImage()
  const topUrl = `url(${img('/banners/top-layout/top.png', { format: 'webp' })})`

  const { isAuthenticated, isHaveDigitalProfile } = useUserStore()
  const router = useRouter()
  const { openModal } = useAuthModal()

  const navigateToProfile = () => {
    if (!isAuthenticated) {
      openModal({ backUrl: '/account/my-profile' })
      return
    }

    const routePath = isHaveDigitalProfile ? '/account/my-profile' : '/account/my-profile/creat'
    router.push(routePath)
  }

  const topLayoutBannerData = computed(() => {
    return {
      title: isHaveDigitalProfile
        ? 'Посмотреть мой профиль'
        : 'Заполни профиль на 100%, а мы подготовим резюме',
      buttonName: isHaveDigitalProfile ? 'Посмотреть' : 'Заполнить',
    }
  })
</script>

<style scoped lang="scss">
  .top-layout-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    min-height: 62px;
    background-image: v-bind(topUrl);

    @include vp-1439 {
      padding: 10px;
    }
    @include vp-767 {
      height: 48px;
      padding: 10px;
    }

    > .title {
      font-weight: 600;
      font-size: 22px;
      line-height: 100%;
      text-transform: uppercase;
      color: $color-potato-90;

      @include vp-1439 {
        font-size: 20px;
        padding-right: 20px;
      }

      @include vp-767 {
        font-size: 14px;
        line-height: 16px;
      }
    }

    > .button {
      min-width: 150px;
      background-color: $color-kiwi-50;
    }
  }
</style>
